import { warn } from '../../../logger';
import { InternalElementFactoryOptions, SdkElement } from '../../../model';
import { recordEvent } from '../../../telemetry';
import { SDKError } from '../../error';
import {
  PaymentInstructionsElement,
  PaymentInstructionsElementOptions
} from './PaymentInstructionsElement';
import { parsePaymentInstructionsOptions } from './paymentInstructionsOptionsSchema';

export const createPaymentInstructionsElement = async (
  elementOptions: PaymentInstructionsElementOptions,
  commonOptions: InternalElementFactoryOptions
): Promise<SdkElement> => {
  await recordEvent('sdk_payment_instructions_element_init_options', {
    payment_instructions_element_options: { ...elementOptions },
    elements_options: commonOptions
  });

  const {
    errors,
    warnings,
    options: validatedOptions,
    initialOptions
  } = parsePaymentInstructionsOptions(elementOptions);

  if (errors) {
    throw new SDKError(
      'invalidPaymentInstructionsElementOptions',
      'Invalid Payment Instructions Element options provided.',
      errors
    );
  }

  if (warnings) {
    warn('invalidPaymentInstructionsElementOptions', warnings);
  }

  await recordEvent('sdk_payment_instructions_element_options_validated', {
    payment_instructions_element_warnings: warnings,
    payment_instructions_element_options: initialOptions,
    elements_options: commonOptions
  });

  return PaymentInstructionsElement({ ...validatedOptions, ...commonOptions });
};
